export default __webpack_public_path__ + "static/media/Mama_Liz.033d3072.webp";